import { DocTemplateFolderTypeVals } from '../../helpers/constants/modelValues/DocTemplateFolderTypeVals';
import {
    getPDFStatusBadge,
    isCheckedOrderDocument,
    OrderDocumentCheckedLabel,
    ProjectDocFolderStatuses
} from '../mapping/ProjectDocFolderStatuses';
import { ProjectDocFolder } from '../../pages/projectDocs/models/ProjectDocFolder';
import { ProjectDocFolderTreeNode } from '../../pages/projectDocs/models/ProjectDocFolderTreeNode';
import { ProjectDocFolderSubTypes } from '../mapping/ProjectDocFolderSubTypes';
import {
    ALL_SYSTEM_FOLDER_TITLES,
    SectionSystemFolderTitles
} from '../constants/systemValues/SectionSystemFolderTitles';

function folderTreeBadgeLabel(folder: ProjectDocFolder, statuses: { [key: number]: string }): string {
    if (isCheckedOrderDocument(folder.StatusId, folder.DocumentTypeId)) {
        return OrderDocumentCheckedLabel;
    }
    if (
        folder.StatusId === ProjectDocFolderStatuses.NoData ||
        folder.StatusId === ProjectDocFolderStatuses.OrderDocument
    ) {
        return ``;
    }
    return statuses[folder.StatusId ?? 0] ?? ``;
}

function folderTreeBadgeClass(folder: ProjectDocFolder): string {
    return isCheckedOrderDocument(folder.StatusId, folder.DocumentTypeId)
        ? `badge badge-success`
        : getPDFStatusBadge(folder.StatusId);
}

function getFolderTypeIcon(folderTypeId: number | undefined): string {
    if (folderTypeId === DocTemplateFolderTypeVals.Act) return 'fa fa-file-pen';
    const isSectionType =
        folderTypeId === DocTemplateFolderTypeVals.Section ||
        folderTypeId === DocTemplateFolderTypeVals.ActDocumentSection ||
        folderTypeId === DocTemplateFolderTypeVals.ActSection ||
        folderTypeId === DocTemplateFolderTypeVals.PaperSigningRoot;
    return isSectionType ? 'fa fa-folder' : 'fa fa-file';
}

export function convertToProjectDocFolder(nodes: ProjectDocFolderTreeNode[]): ProjectDocFolder[] {
    return nodes.map((node) => {
        return {
            Id: node.key as number,
            Title: node.label ?? ``,
            ParentId: node.ParentId,
            ChangeParentId: node.ChangeParentId,
            ProjectDocId: node.TemplateId,
            FolderTypeId: node.FolderTypeId,
            SubTypeId: node.SubTypeId,
            SurveyTypeId: node.SurveyTypeId,
            InputControl: node.InputControl,
            DisablePrimaryEmailNotification: node.DisablePrimaryEmailNotification,
            StatusId: node.StatusId,
            Position: 0,
            Cypher: ``,
            Attachments: [],
            Children: convertToProjectDocFolder(node.children),
            ChangeChildren: [],
            ProjectDocFolderCUsers: []
        };
    });
}

export function buildArray(pdf: ProjectDocFolder | undefined) {
    return pdf ? [pdf, ...pdf.Children] : [];
}

export function buildTreeFromProjectDocFolders(
    folders: ProjectDocFolder[],
    statuses: { [key: number]: string },
    parentId?: number | null
): ProjectDocFolderTreeNode[] {
    if (folders.length === 0) return [];

    var nodes = folders.filter((x) => x.ParentId === parentId).sort((x1, x2) => x1.Position - x2.Position);

    if (
        nodes.filter(
            (x) =>
                x.FolderTypeId == DocTemplateFolderTypeVals.Tom ||
                x.FolderTypeId == DocTemplateFolderTypeVals.Act ||
                x.FolderTypeId == DocTemplateFolderTypeVals.ActDocument
        )?.length > 0
    ) {
        var newNodes: ProjectDocFolder[] = [];
        var prevNodes: ProjectDocFolder[] = [];
        nodes.map((r) => {
            if (r.FolderTypeId == DocTemplateFolderTypeVals.Tom) {
                //Для тома определяем отца
                if (r.ChangeChildren?.length > 0) {
                    var father = r; //Записываем данные отца
                    //console.log("father", father);
                    //Определяем старшего ребенка
                    var theEldestChildren = r.ChangeChildren.reduce((oldest, current) => {
                        if (current.Created && oldest.Created) {
                            if (current.Created > oldest.Created) {
                                return current;
                            } else {
                                return oldest;
                            }
                        }
                        return current;
                    }, r.ChangeChildren[0]);
                    //console.log("theEldestChildren", theEldestChildren);
                    var newFather = theEldestChildren; //Старейший ребенок становится отцом
                    newFather['extended'] = false; //Скрываем детей отца
                    newFather.Children = []; //Обнуляем список детей нового отца
                    r.ChangeChildren.sort((a: any, b: any) => {
                        const dateA = new Date(a.Created);
                        const dateB = new Date(b.Created);

                        if (dateA > dateB) {
                            return -1;
                        } else if (dateA < dateB) {
                            return 1;
                        } else {
                            return 0;
                        }
                    });
                    //Бежим по всем детям отца
                    var index = r.ChangeChildren.length - 1;
                    r.ChangeChildren.forEach((x) => {
                        //Добавляем новому отцу всех детей, без старого отца
                        if (x.Id != newFather.Id) {
                            //Генерация OrderNumber
                            if (x.SubTypeId == ProjectDocFolderSubTypes.Change) {
                                x['OrderNumber'] = index;
                                index--;
                            }
                            newFather.Children.push(x);
                        }
                    });
                    newFather.Children.push(father); //Новому отцу пихаем старого отца
                    newFather['OrderNumber'] = newFather.Children.length;
                    newNodes.push(newFather);
                    //console.log("newFather", newFather);
                } else {
                    if (r.ChangeParentId == null) {
                        newNodes.push(r);
                    }
                }
            } else {
                prevNodes.push(r);
            }
        });
        if (newNodes.length > 0) {
            nodes = newNodes;
            return [
                ...nodes.map((r, index) => {
                    var model = {
                        key: r.Id,
                        extended: r['extended'],
                        label: r.Title,
                        data: r,
                        ParentId: parentId === null ? undefined : parentId,
                        ChangeParentId: r.ChangeParentId,
                        StatusId: r.StatusId,
                        SubTypeId: r.SubTypeId,
                        SurveyTypeId: r.SurveyTypeId,
                        OrderNumber: r['OrderNumber'],
                        InputControl: r.InputControl,
                        DisablePrimaryEmailNotification: r.DisablePrimaryEmailNotification,
                        bagdeClass: folderTreeBadgeClass(r),
                        bagdeValue: folderTreeBadgeLabel(r, statuses),
                        TemplateId: r.ProjectDocId,
                        FolderTypeId: r.FolderTypeId,
                        Cypher: r.Cypher,
                        icon: getFolderTypeIcon(r.FolderTypeId),
                        children: buildTreeFromProjectDocFoldersChildren(r.Children, statuses, r.Id)
                    };
                    //console.log("model", model);
                    return model;
                }),
                ...prevNodes.map((r, index) => {
                    var model = {
                        key: r.Id,
                        label: r.Title,
                        data: r,
                        ParentId: parentId === null ? undefined : parentId,
                        ChangeParentId: r.ChangeParentId,
                        StatusId: r.StatusId,
                        SubTypeId: r.SubTypeId,
                        SurveyTypeId: r.SurveyTypeId,
                        InputControl: r.InputControl,
                        DisablePrimaryEmailNotification: r.DisablePrimaryEmailNotification,
                        bagdeClass: folderTreeBadgeClass(r),
                        bagdeValue: folderTreeBadgeLabel(r, statuses),
                        TemplateId: r.ProjectDocId,
                        FolderTypeId: r.FolderTypeId,
                        Cypher: r.Cypher,
                        icon: getFolderTypeIcon(r.FolderTypeId),
                        children: buildTreeFromProjectDocFolders(
                            folders.filter((x) => x.ParentId !== parentId).sort((x1, x2) => x1.Position - x2.Position),
                            statuses,
                            r.Id
                        )
                    };
                    //console.log("model", model);
                    return model;
                })
            ];
        }
    }

    //console.log("nodes", nodes);

    return nodes.map((r, index) => {
        var model = {
            key: r.Id,
            label: r.Title,
            data: r,
            ParentId: parentId === null ? undefined : parentId,
            ChangeParentId: r.ChangeParentId,
            StatusId: r.StatusId,
            SubTypeId: r.SubTypeId,
            SurveyTypeId: r.SurveyTypeId,
            InputControl: r.InputControl,
            DisablePrimaryEmailNotification: r.DisablePrimaryEmailNotification,
            bagdeClass: folderTreeBadgeClass(r),
            bagdeValue: folderTreeBadgeLabel(r, statuses),
            TemplateId: r.ProjectDocId,
            FolderTypeId: r.FolderTypeId,
            Cypher: r.Cypher,
            icon: getFolderTypeIcon(r.FolderTypeId),
            children: buildTreeFromProjectDocFolders(
                folders.filter((x) => x.ParentId !== parentId).sort((x1, x2) => x1.Position - x2.Position),
                statuses,
                r.Id
            )
        };
        //console.log("model", model);
        return model;
    });
}

export function buildTreeFromProjectDocFoldersChildren(
    folders: any[],
    statuses: { [key: number]: string },
    parentId?: number | null
): ProjectDocFolderTreeNode[] {
    if (folders.length === 0) return [];

    return folders.map((r) => {
        var model = {
            key: r.Id,
            label: r.Title,
            data: r,
            ParentId: parentId === null ? undefined : parentId,
            ChangeParentId: r.ChangeParentId,
            StatusId: r.StatusId,
            SubTypeId: r.SubTypeId,
            SurveyTypeId: r.SurveyTypeId,
            OrderNumber: r['OrderNumber'],
            InputControl: r.InputControl,
            DisablePrimaryEmailNotification: r.DisablePrimaryEmailNotification,
            bagdeClass: folderTreeBadgeClass(r),
            bagdeValue: folderTreeBadgeLabel(r, statuses),
            TemplateId: r.ProjectDocId,
            FolderTypeId: r.FolderTypeId,
            Cypher: r.Cypher,
            Approvers: r.WorkflowApprovers?.map((x) => x.User?.Title || '') || [],
            icon: getFolderTypeIcon(r.FolderTypeId),
            children: buildTreeFromProjectDocFolders(
                folders.filter((x) => x.ParentId !== parentId).sort((x1, x2) => x1.Position - x2.Position),
                statuses,
                r.Id
            )
        };
        //console.log("model", model);
        return model;
    });
}

export function markGeneralSectionNodes(nodes: ProjectDocFolderTreeNode[]): void {
    for (const node of nodes) {
        const isGeneralSection =
            node.FolderTypeId === DocTemplateFolderTypeVals.Section &&
            node.ParentId == null &&
            typeof node.label === 'string' &&
            node.label.toLowerCase().includes('общие документ');

        if (isGeneralSection) {
            markChildrenAsInGeneralSection(node.children as ProjectDocFolderTreeNode[]);
        } else {
            markGeneralSectionNodes(node.children as ProjectDocFolderTreeNode[]);
        }
    }
}

/* Иконки для дерева ИД + генподряд. Вызывать после markGeneralSectionNodes. */
export function assignIdTreeIcons(nodes: ProjectDocFolderTreeNode[], isNested: boolean = false): void {
    for (const node of nodes) {
        const isSection =
            node.FolderTypeId === DocTemplateFolderTypeVals.Section ||
            node.FolderTypeId === DocTemplateFolderTypeVals.ActDocumentSection ||
            node.FolderTypeId === DocTemplateFolderTypeVals.ActSection;

        if (isSection) {
            if (node.label === SectionSystemFolderTitles.ActsOS) {
                node.icon = 'fa-solid fa-helmet-safety';
            } else if (node.label === SectionSystemFolderTitles.ActsIS) {
                node.icon = 'fa-solid fa-plug-circle-check';
            } else if (node['isInGeneralSection']) {
                if (node.label === 'Приказы на ответственных') {
                    node.icon = 'fa-solid fa-address-card';
                } else if (node.label === 'Журнал входного контроля' || node.label === 'Общий журнал работ') {
                    node.icon = 'fa-solid fa-book-open';
                }
            } else if (ALL_SYSTEM_FOLDER_TITLES.includes(node.label ?? '')) {
                /* пропускаем, дефолтная папка */
            } else if (!isNested) {
                node.icon = 'fa-solid fa-folder-closed';
            } else {
                node.icon = 'fa-solid fa-folder-open';
            }
        }
        assignIdTreeIcons(node.children as ProjectDocFolderTreeNode[], true);
    }
}

function markChildrenAsInGeneralSection(nodes: ProjectDocFolderTreeNode[]): void {
    for (const node of nodes) {
        node['isInGeneralSection'] = true;
        markChildrenAsInGeneralSection(node.children as ProjectDocFolderTreeNode[]);
    }
}
